module.exports = __webpack_public_path__ + "img/img_logo.824f46d5.png";